import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Each portal (Super Admin / Doctor / Receptionist) keeps its own auth cookie on the
// backend so logging into one portal in a tab never clobbers another portal's session
// in a different tab. This hint lets shared routes like /auth/me and /auth/logout know
// which portal's cookie to use, based on the current page path.
function currentRoleHint() {
  const path = window.location.pathname;
  if (path.startsWith("/ali-admin-portal")) return "super_admin";
  if (path.startsWith("/doctor")) return "doctor";
  if (path.startsWith("/staff")) return "receptionist";
  return null;
}

api.interceptors.request.use((config) => {
  const hint = currentRoleHint();
  if (hint) {
    config.headers["X-Role-Hint"] = hint;
  }
  return config;
});

// Single Active Session enforcement: any 401 (e.g. this device's session was replaced
// by a login elsewhere) flows through here from EVERY api call, not just /auth/me, so
// AuthContext can force-logout+redirect the instant any request fails this way.
let unauthorizedHandler = null;
export function setUnauthorizedHandler(fn) {
  unauthorizedHandler = fn;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      unauthorizedHandler?.(error.response?.data?.detail);
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
